import React, {Component} from "react";
import {Modal, FormGroup, FormControl, ControlLabel} from "react-bootstrap";
import Button from "../CustomButton/CustomButton";
import ReactPlayer from 'react-player'

class ModalVideoPlayer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showVideoPlayerModal: true,

            videoUrl: 'https://',
            videoStatus: null,
            duration: null,
            progress: null,
            playing: false,
            error: "",
            pip: true

        };

    }

    handleClose = () => {
        this.setState({showVideoPlayerModal: false, playing: false})
        this.props.handlerFromParent();
    }

    componentDidMount() {
        //console.log(this.props.handlerID)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        // if (this.props.handlerID !== prevProps.handlerID) {
            // if (this.props.handlerID !== undefined) {
            //     if (this.props.handlerID !== "") {
            //         this.setState({videoUrl: this.props.handlerID})
            //         console.log(this.props.handlerID)
            //     }
            // }
        // }
    }

    onError(e) {
        //console.log(e)
        if (e === "hlsError") {
            this.setState({videoStatus: "failed to load", playing: false})
        }
        this.setState({error: e})
    }

    onDuration = (duration) => {
        //console.log('onDuration', duration)
        this.setState({duration, playing: true})
    }

    onProgress = state => {
        //console.log('onProgress', state)
        // We only want to update time slider if we are not currently seeking
        if (!this.state.seeking) {
            this.setState(state)
        }
    }

    onEnded = () => {
        //console.log('onEnded')
        this.setState({playing: false, videoStatus: "finished"})
    }

    onPause = () => {
        //console.log('onPause')
        this.setState({playing: false, videoStatus: "paused"})
    }

    onPlay = () => {
        //console.log('onPlay')
        this.setState({playing: true, videoStatus: "playing"})
    }

    onReady = () => {
        //console.log('onReady')
        this.setState({videoStatus: "ready"})
    }

    onStart = () => {
        //console.log('onStart')
        this.setState({videoStatus: "onStart"})
    }

    handleEnablePIP = () => {
        //console.log('onEnablePIP')
        this.setState({pip: true})
    }

    handleDisablePIP = () => {
        //console.log('onDisablePIP')
        this.setState({pip: false})
    }

    render() {

        return (
            <div className="modal-video-player">
                <Modal show={this.state.showVideoPlayerModal} onHide={this.handleClose}>
                    <Modal.Header closeButton style={{backgroundColor: '#fbfbfb'}}>
                        <Modal.Title>Video Player</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <ReactPlayer
                                className='reactPlayerCSS'
                                url={this.props.handlerID === undefined ? "https://" : this.props.handlerID}
                                width='100%'
                                height='100%'
                                playing={this.state.playing}
                                controls
                                pip={this.state.pip}
                                onError={(e) => this.onError(e)}
                                onReady={() => this.onReady}
                                onStart={() => this.onStart}
                                onPlay={this.onPlay}
                                onEnablePIP={this.handleEnablePIP}
                                onDisablePIP={this.handleDisablePIP}
                                onPause={this.onPause}
                                // onBuffer={() => console.log('onBuffer')}
                                // onSeek={(e) => console.log('onSeek', e)}
                                onEnded={this.onEnded}
                                onProgress={(e) => this.onProgress(e)}
                                onDuration={(e) => this.onDuration(e)}
                                //preload={false}
                            />
                        </div>
                        <div>
                            <FormGroup>
                                <ControlLabel>PLAYBACK URL</ControlLabel>
                                <FormControl
                                    type="text"
                                    disabled={true}
                                    name="handlerID"
                                    value={this.props.handlerID || ''}
                                    placeholder="Playback url"
                                />
                            </FormGroup>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle="default" fill onClick={this.handleClose}> close </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

}

export default ModalVideoPlayer;
